import { Button, Tooltip } from '@appkit4/react-components';
import useLocale from 'locale/useLocale';
import {
    DataCorrectionAttendedoffice,
    HistoryRow,
} from 'pages/history/History';

type UnforeseenReasonsCellRendererProps = {
    row: HistoryRow | null | undefined;
    field: string;
};

const UnforeseenReasonsCellRenderer = ({
    row,
    field,
}: UnforeseenReasonsCellRendererProps) => {
    const { l } = useLocale();
    const reasons = row ? row[field as keyof HistoryRow] : null;

    if (
        reasons === null ||
        reasons === undefined ||
        (Array.isArray(reasons) && reasons.length === 0)
    ) {
        return null;
    }

    return (
        <>
            <div>
                {Array.isArray(reasons) &&
                    reasons.map(
                        (
                            reason:
                                | string
                                | { startDate: string; endDate: string },
                            index: number
                        ) => (
                            <div key={index}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    {typeof reason === 'string' ? reason : null}
                                    {reason ===
                                        DataCorrectionAttendedoffice && (
                                        <Tooltip
                                            trigger="hover"
                                            id="disabled dates tooltip"
                                            content={l(
                                                '_DataCorrectionAttendedOfficeTooltipText'
                                            )}
                                        >
                                            <Button
                                                add
                                                icon="icon-information-outline"
                                                compact
                                                kind={'text'}
                                            />
                                        </Tooltip>
                                    )}
                                </div>
                            </div>
                        )
                    )}
            </div>
        </>
    );
};

export default UnforeseenReasonsCellRenderer;
